import { render } from "./Foto.vue?vue&type=template&id=15e59002&scoped=true"
import script from "./Foto.vue?vue&type=script&lang=js"
export * from "./Foto.vue?vue&type=script&lang=js"

import "./Foto.vue?vue&type=style&index=0&id=15e59002&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e59002"]])

export default __exports__